__turbopack_context__.v({
  "blog_archive": "styles-module-scss-module__qm6_na__blog_archive",
  "blog_banner": "styles-module-scss-module__qm6_na__blog_banner",
  "blog_banner_img": "styles-module-scss-module__qm6_na__blog_banner_img",
  "blog_cta": "styles-module-scss-module__qm6_na__blog_cta",
  "blog_cta_text": "styles-module-scss-module__qm6_na__blog_cta_text",
  "blog_header": "styles-module-scss-module__qm6_na__blog_header",
  "header_link": "styles-module-scss-module__qm6_na__header_link",
});
